// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"qc_qe","disabled":"qc_qf","active":"qc_pi","toggleButtonLeft":"qc_qg","toggleButtonRight":"qc_qh"};